import React, { useState } from "react";
import styled from "styled-components";
import { Tabs } from "antd";
import PhotoCloudStats from "./PhotoCloudStats";
import VendorManagement from "./VendorManagement";
import GalleryManagement from "./GalleryManagement";

const PageWrapper = styled.div`
  animation: fadeIn 0.3s ease;
  @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
`;
const PageHeader = styled.div`
  margin-bottom: 24px;
`;
const PageTitle = styled.h1`
  font-size: 26px; font-weight: 600; color: #1e293b; letter-spacing: -0.5px; margin: 0;
`;
const PageSubtitle = styled.p`font-size: 14px; color: #64748b; margin: 4px 0 0;`;

function PhotoCloudPage() {
  const [activeTab, setActiveTab] = useState("stats");

  return (
    <PageWrapper>
      <PageHeader>
        <PageTitle>Photo Cloud</PageTitle>
        <PageSubtitle>Manage event photo galleries, vendors, and publishing.</PageSubtitle>
      </PageHeader>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          { key: "stats", label: "Overview", children: <PhotoCloudStats /> },
          { key: "vendors", label: "Vendors", children: <VendorManagement /> },
          { key: "galleries", label: "Galleries", children: <GalleryManagement /> },
        ]}
      />
    </PageWrapper>
  );
}

export default PhotoCloudPage;
